import { render, staticRenderFns } from "./IndexRole.vue?vue&type=template&id=175048c7"
import script from "./IndexRole.vue?vue&type=script&lang=js"
export * from "./IndexRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports